import {StepConnector, stepConnectorClasses} from '@mui/material';
import {styled} from '@mui/material/styles';

const CustomizeConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    left: 'calc(-50% + 0.875rem)',
    right: 'calc(50% + 1rem)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#4caf50',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#4caf50',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#888888',
    borderTopWidth: '0.125rem',
  },
}));

export default CustomizeConnector;
